import React from "react"

const DropboxLabel = ({searchCategory}) => {
  return (
    <div className="font-bold mr-2 xl:max-w-20 lg:max-w-14 lg:text-sm md:text-xs min-w-6 xl:text-base content-center">
      {searchCategory}
    </div>
  )
}

export default DropboxLabel